import { PaymentIntervalList } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const paymentIntervalUtils = createArrayUtils(PaymentIntervalList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:paymentInterval',
    createDefaultValue: () => 'monthly',
    excludeOptions: ['unknown'],
});
